module.exports = __webpack_public_path__ + "pc/media/emotion_main_video.9bdd387c.webm";